<script setup>
import TicketsTable from '@/Pages/PartnerSupport/Tickets/Partials/TicketsTable.vue';

const props = defineProps({
  filters: {
    type: Object,
    default: () => ({}),
  },
  statusOptions: {
    type: Array,
    required: true,
  },
  priorityOptions: {
    type: Array,
    required: true,
  },
  filterSelections: {
    type: Array,
    required: true,
  },
});
</script>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

export default {
  layout: DashboardLayout,
};
</script>

<template>
  <div class="bg-white py-5">
    <div class="container-fluid">
      <div class="px-4">
        <tickets-table
          :filters="filters"
          :priority-options="priorityOptions"
          :status-options="statusOptions"
          :filterSelections="filterSelections"
        ></tickets-table>
      </div>
    </div>
  </div>
</template>